export const COOKIE_NAME = 'HIDE_PHI';
export const EVENT_NAME = 'hide-phi';

export const PhiMode = {
  Blur: 'blur',
  Redact: 'redact'
} as const;

export type PhiMode = ValueOf<typeof PhiMode>;